import React from "react";

import { Icon, IconProps } from "../";

export const ArrowLastIcon = (props: IconProps) => {
  return (
    <Icon {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.73967 6.0496C6.43613 5.76775 6.41856 5.2932 6.70041 4.98966C6.98226 4.68613 7.45681 4.66856 7.76034 4.95041L14.7603 11.4504C14.9132 11.5923 15 11.7915 15 12C15 12.2086 14.9132 12.4077 14.7603 12.5496L7.76034 19.0496C7.45681 19.3314 6.98226 19.3139 6.70041 19.0103C6.41856 18.7068 6.43613 18.2323 6.73967 17.9504L13.1478 12L6.73967 6.0496ZM16 5.5C16 5.08579 16.3358 4.75 16.75 4.75C17.1642 4.75 17.5 5.08579 17.5 5.5V18.5C17.5 18.9142 17.1642 19.25 16.75 19.25C16.3358 19.25 16 18.9142 16 18.5V5.5Z"
      />
    </Icon>
  );
};
